/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchRequestModel } from '../../models/search-request-model';
import { SearchRoleResultModelSearchResultModel } from '../../models/search-role-result-model-search-result-model';

export interface RoleSearchRolePost$Params {
      body?: SearchRequestModel
}

export function roleSearchRolePost(http: HttpClient, rootUrl: string, params?: RoleSearchRolePost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<SearchRoleResultModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, roleSearchRolePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as AuthStrictHttpResponse<SearchRoleResultModelSearchResultModel>;
    })
  );
}

roleSearchRolePost.PATH = '/Role/SearchRole';
